import OfficeReviewsPageWithData from './OfficeReviewsPageWithData';

export default OfficeReviewsPageWithData;
